export { BROADCAST_FF } from '@lumapps/broadcasts/constants';

export const DISTRIBUTE_CONTENT_FF = 'broadcast-distribute-content';

export enum DISTRIBUTE_IFRAME_EVENT {
    CLOSE = 'distribute-iframe-event-close',
    CREATED = 'distribute-iframe-event-created',
    ERROR = 'distribute-iframe-event-error',
}
